import postsAction from "../actions/posts.action";

export default (state, action) => {
  switch (action.type) {
    case postsAction.SET_RECENTS:
      return {
        ...state,
        recents: action.payload.data,
      };
    case postsAction.SET_VIEWED:
      return {
        ...state,
        viewed: action.payload.data,
      };
    case postsAction.SET_LIKED:
      return {
        ...state,
        liked: action.payload.data,
      };
    case postsAction.SET_RATED:
      return {
        ...state,
        rated: action.payload.data,
      };
    default:
      return state;
  } // end switch
};
